import React, { createContext, useContext, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import translations from '../translations.json';
import { buildPath, getRouteInfo } from '../seo/config';

const LanguageContext = createContext();

export const useLanguage = () => {
      const context = useContext(LanguageContext);
      if (!context) {
            throw new Error('useLanguage must be used within a LanguageProvider');
      }
      return context;
};

export const readTranslationByKey = (lang, key) => {
      const keys = key.split('.');
      let value = translations[lang];
      
      for (const k of keys) {
            if (value && typeof value === 'object') {
                  value = value[k];
            } else {
                  return key;
            }
      }
      
      return value || key;
};

export const LanguageProvider = ({ children }) => {
      const location = useLocation();
      const navigate = useNavigate();
      const route = getRouteInfo(location.pathname);
      const language = route.language;

      useEffect(() => {
            try {
                  localStorage.setItem('agrollama_language', language);
            } catch {
                  // Language is encoded in the URL; storage is only a convenience.
            }
      }, [language]);

      const pathFor = (page) => buildPath(language, page);
      const languagePath = (nextLanguage) =>
            buildPath(nextLanguage, route.isKnown ? route.page : 'home');
      const setLanguage = (nextLanguage) => {
            navigate(languagePath(nextLanguage));
      };

      const t = (key) => readTranslationByKey(language, key);

      const value = {
            language,
            setLanguage,
            pathFor,
            languagePath,
            t,
      };

      return (
            <LanguageContext.Provider value={value}>
                  {children}
            </LanguageContext.Provider>
      );
};
